import React from "react";
import RestUtilities, { IRestResponse } from '../../../services/RestUtilities';
import { TableRow, TableCell, Snackbar } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit'
import CloseIcon from '@mui/icons-material/Close'
import SnackbarWrapper from '../../../components/SnackbarWrapper'
import Loader from '../../../components/Loader';
import { GrowMessage } from "../../../components/GrowMessage";

interface IKeyable {
    [key: string]: any
} 

function MasterData<T extends IKeyable, K extends keyof T>(WrappedComponent: any, type: { new(): T[K] ;} ) {

    class MasterDataFilter {
        [key: string]: string
        name: string = ''
        description: string = '' 
    }

    return class extends React.Component<any, any> {

        state = {
            tableData: [] as T[],
            addNew: false,
            mode: 'create',
            filter: new MasterDataFilter(),
            newObject: new type(),
            showError: false,
            errorMessage: '',
            loading: false
        }

        componentDidMount() {
            this.fetchData()
        }

        changeMode = (newMode: string) => {
            this.setState({ mode: newMode })
        }

        showAddNew = ():void => {
            this.setState({ addNew: true })
        }

        hideAddNew = (): void => {
            this.setState({ addNew: false, newObject: new type(), loading: false })
        }

        clearFilters = ():void => {
            const newFilter = new MasterDataFilter()
    
            this.setState({ filter: newFilter })
            this.fetchData()
        }

        handleFilterChange = (event: any): void => {
            const newFilter = { ...this.state.filter }
    
            
            newFilter[event.target.name] = event.target.value
    
            this.setState({ filter: newFilter })
        }

        handleSearch = (): void => {
            this.fetchData((Object as any).entries(this.state.filter))
        }

        handleChangeNewObject = (event: any): void => {
            const newObject = new type()
            Object.assign(newObject, this.state.newObject)
            const fieldName: any = event.target.name
    
            newObject[fieldName] = event.target.value
    
            this.setState({ newObject: newObject })
        }

        handleSnackbarClose = (event: any, reason: string) => {
            if (reason === 'clickaway')
                return;
    
            this.setState({ showError:false })
        }

        fetchData = (...args: any[][]) => {

            this.setState({ loading: true })

            let url = `/api/${type.modelName}?`

            if (args.length > 0) {
                args[0].map(x => {
                    if(x[1] !== '')
                        url += `${x[0]}=${x[1]}&`
                })
            }

            RestUtilities.get<T>(url)
                .then(resp => {
                    this.setState({ tableData: resp.content, loading: false })
                }).catch(resp => {
                     this.setState({ tableData: [], loading: false })
                    this.showError(resp)
                })
        }

        delete = (id: number): void => {
            let url = `/api/${type.modelName}/Delete?id=${id}`
            RestUtilities.delete(url)
                .then(resp => {
                    this.fetchData()
                })
                .catch(resp => {
                    this.showError(resp)
                })
        }

        editItem = (): void => {
            this.setState({ loading: true })

            RestUtilities.put<T>(`/api/${type.modelName}/Update`, this.state.newObject)
                .then(resp => {
                    this.hideAddNew()
                    this.fetchData()
                })
                .catch(resp => {
                    this.showError(resp)
                })
        }

        submitNewObject = (): void => {
            if (this.state.mode === 'edit') {
                this.editItem()
                return
            }

            this.setState({ loading: true })
            RestUtilities.post(`/api/${type.modelName}/Create`, this.state.newObject)
                .then(resp => {
                    this.fetchData()
                    this.hideAddNew()
                })
                .catch(resp => {
                    this.showError(resp)
                })
        }

        mapRowCells = (item: T): JSX.Element => {
            return <TableRow key={item.id}>
                {Object.keys(item).map((x, index) => {
                    if(typeof item[x] === 'boolean')
                        return <TableCell key={item.id + x}>{item[x] ? 'ja' : 'nein'}</TableCell>

                    return <TableCell key={item.id + x}>{item[x]}</TableCell>
                })}
                <TableCell key={'actions'}>
                    <EditIcon className='icon' onClick={() => {
                        this.changeMode('edit')
                        this.setState({ newObject: item })
                        this.showAddNew()
                    }} />
                    <CloseIcon className='icon' onClick={() => this.delete(parseInt(item.id))} />
                </TableCell>
            </TableRow>
        }

        showError = (resp: IRestResponse<T>): void => {
            if(typeof resp.error_content != 'undefined' && resp.error_content) {
                this.setState({ showError: true, errorMessage: resp.error_content, loading: false })
            }
        }

        public render() {
            let rows = this.state.tableData.map(x => {
                return this.mapRowCells(x)
            })
            return (
                <>
                    <WrappedComponent
                        newObject={this.state.newObject}
                        filter={this.state.filter}
                        handleChangeNewObject={this.handleChangeNewObject}
                        submitNewObject={this.submitNewObject}
                        handleSearch={this.handleSearch}
                        handleFilterChange={this.handleFilterChange}
                        clearFilters={this.clearFilters}
                        addNew={this.state.addNew}
                        showAddNew={this.showAddNew}
                        hideAddNew={this.hideAddNew}
                        changeMode={this.changeMode}
                        rows={rows} />
                    <GrowMessage
                        anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                        }}
                        message={this.state.errorMessage}
                        visible={this.state.showError}
                        autoHideDuration={6000}
                        onClose={this.handleSnackbarClose} ></GrowMessage>  
                    {this.state.loading && <Loader />}
                </>)
        }
    }
}

export default MasterData